// extracted by mini-css-extract-plugin
export default {"buttons":"Remove_buttons__vRdx5"};